// @flow
/* eslint-disable no-use-before-define */

export type VehicleClass = $Values<typeof VEHICLE_CLASS>
export type VehicleClassName = $Keys<typeof VEHICLE_CLASS>

const VEHICLE_CLASS = {
  FIRST: 1,
  BUSINESS: 2,
  ECONOMY: 3,
  STANDARD: 4,
  GREEN_STANDARD: 6,
  GREEN_PREMIUM: 7,
  BUSINESS_VAN: 5,
}

export default VEHICLE_CLASS
